import React from 'react';

import { EntityHistoryResponseType } from 'utils/api/modules/entities/entities.types';

import HistoryRow from './HistoryRow';
import { HistoryParagraph } from './utils';

const ImportedRow = ({ item }: { item: EntityHistoryResponseType }): React.ReactElement => {
  const { entityField, createdAt } = item;

  return (
    <HistoryRow item={item}>
      <HistoryParagraph key={`${entityField.uuid}-${createdAt}`}>Event imported by Vatix</HistoryParagraph>
    </HistoryRow>
  );
};

export default ImportedRow;
